import { $axios, dealWithErrors } from '../import/http'
import store from '@/store'
import filter from '../import/filter'

const filteredKeys = [
  {
    path: '',
    loop: false,
    keys: [
      {
        key: 'id',
        type: 'int',
      },
      {
        key: 'name',
        type: 'string',
      },
      {
        key: 'code',
        type: 'string',
      },
      {
        key: 'symbol',
        type: 'string',
      },
      {
        key: 'rate',
        type: 'string',
      },
      {
        key: 'amount',
        type: 'string',
      },
      {
        key: 'created_at',
        type: 'date',
      },
      {
        key: 'updated_at',
        type: 'date',
      },
    ],
  },
]

export default {
  namespaced: true,
  state: {
    items: [],
  },
  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
  },
  actions: {
    getList({ commit }) {
      return new Promise((resolve, reject) => {
        $axios.get('/currency', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.state.token.access_token,
          },
        }).then(response => {
          commit('SET_ITEMS', response.data)
          resolve()
        }).catch(error => {
          dealWithErrors(error)
          reject(error)
        })
      })
    },
  },
  getters: {
    allItems: (state) => (searchText = '') => {
      if (searchText.trim().length > 0) {
        return filter.methods.filterItems(state.items, filteredKeys, searchText)
      }
      return state.items
    },
  },
}
